
export const truncateText = (text, maxLength = 50) => {
    if (!text || typeof text !== 'string') {
      return { text: '', title: '' };
    }
    
    if (text.length <= maxLength) {
      return { text, title: '' };
    }
    
    const truncatedText = text.substring(0, maxLength) + '...';
    return { text: truncatedText, title: text };
  };
  
  
  export const TruncatedText = ({ text, maxLength = 50, className = '' }) => {
    const { text: truncatedText, title } = truncateText(text, maxLength);
    
    return (
      <span className={className} title={title}>
        {truncatedText}
      </span>
    );
  };
  